// extracted by mini-css-extract-plugin
export var legendIndicator = "_e8-1";
export var legendRight = "_e8-0";